import { forwardRef, ReactNode } from 'react';

import { useBehavioralTrackingProps } from '../../core/hooks/useBehavioralTrackingProps.js';
import type { BehaviorTrackingProps } from '../../core/types/behavior-tracking-props.js';
import type { DataTestId } from '../../core/types/data-props.js';
import type { StylingProps } from '../../core/types/styling-props.js';
import { mergeProps } from '../../core/utils/merge-props.js';
import { Flex } from '../../layouts/flex/Flex.js';

//#region Typings
/**
 * Accepted properties for the ToggleButtonGroup Suffix.
 * @public
 */
export interface ToggleButtonGroupSuffixProps
  extends StylingProps,
    DataTestId,
    BehaviorTrackingProps {
  /** Elements to be displayed in the Button Suffix slot. */
  children: ReactNode;
}
//#endregion

/**
 * ToggleButtonGroup Suffix component.
 * @public
 */
export const Suffix = forwardRef<HTMLDivElement, ToggleButtonGroupSuffixProps>(
  ({ children, ...rest }, forwardedRef) => {
    const [behavioralTrackingProps, restProps] =
      useBehavioralTrackingProps(rest);

    return (
      <Flex
        ref={forwardedRef}
        gap={0}
        {...mergeProps(restProps, behavioralTrackingProps)}
      >
        {children}
      </Flex>
    );
  },
);

(Suffix as typeof Suffix & { displayName: string }).displayName =
  'ToggleButtonGroup.Suffix';
